export enum FileType {
  JPG = "image/jpg",
  JPEG = "image/jpeg",
  PNG = "image/png",
  WEBP = "image/webp",
  PDF = "application/pdf",
  SVG = "image/svg+xml",
  GIF = "image/gif",
}
